/**
 * Where a dragged row lands, following the legacy Setup tab's contract.
 *
 * Legacy (`ScheduleTree/index.jsx:686-737`) never computed an index. Its tree
 * library handed it the ALREADY-REORDERED list and it simply read where the
 * node ended up. Reproducing that here removes a whole class of off-by-one
 * bugs: the rule is expressed once, and the drop, the preview and the indicator
 * all consume it, so they cannot disagree.
 *
 * `after` comes from the dragged row's SLOT (see `resolveDropSlot`), not from a
 * guess about intent. An earlier version inferred it from the drag direction
 * and from whether the target was the last row, which left the end of a list
 * unreachable — there was no way to express "below the final team".
 */

/**
 * The destination list as it looks after the drop, dragged row included.
 *
 * `destinationIds` is the destination list BEFORE the drop. When the dragged
 * row is already in it, it is removed first — which is why `after` is applied
 * to the target's index in the REMAINING list rather than its original one.
 */
export const resolveLandedOrder = (
  destinationIds: string[],
  activeId: string,
  overId: string,
  after: boolean
): string[] => {
  const remaining = destinationIds.filter((id) => id !== activeId)
  const overIndex = remaining.indexOf(overId)

  // Dropped against the division row itself rather than a team: append.
  const insertAt =
    overIndex === -1 ? remaining.length : after ? overIndex + 1 : overIndex

  return [
    ...remaining.slice(0, insertAt),
    activeId,
    ...remaining.slice(insertAt),
  ]
}
